import { Component, OnInit, OnDestroy } from '@angular/core';
import { RequestService } from './request.service';
import { Subscription } from 'rxjs';
import * as moment from 'moment';

import { Library } from '@core/library';
@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss']
})
export class RequestComponent implements OnInit, OnDestroy {
  listPendingSub: Subscription;
  pendingOrders = [];

  constructor(
    private requestService: RequestService,
    private library: Library,
  ) { }

  ngOnInit() {
    this.listPendingSub = this.requestService.listPending().subscribe((orders) => {
      this.pendingOrders = orders;
      // console.log(orders);
    });
  }

  getDatetimeString(timestamp) {
    const dateString = moment(timestamp).format('DD/MM/YYYY HH:mm');
    return dateString;

  }

  approveOrder(orderId, orderData) {
    setTimeout(() => {
      const check = confirm('Bạn có muốn duyệt không?');
      if (!check) {
        return false;
      }

      this.library.showloading();
      this.requestService.approve(orderId, orderData).then(() => {
        this.library.showNotify('Phê duyệt thành công');
      }).finally(() => this.library.hideloading());
    }, 100);
  }

  removeOrder(orderId) {
    setTimeout(() => {
      const check = confirm('Bạn có muốn xóa không?');
      if (!check) {
        return false;
      }

      this.library.showloading();
      this.requestService.remove(orderId).then(() => {
        this.library.showNotify('Xóa thành công');
      }).finally(() => this.library.hideloading());
    }, 100);
  }

  ngOnDestroy() {
    this.listPendingSub.unsubscribe();
  }

}
